import { common } from '@kurtosys/ksys-app-template';
import { IFontFace } from '@kurtosys/types/componentStyle/IFontFace.js';
import { createGlobalStyle } from 'styled-components';

export interface IFontFacesProps {
	fontFaces?: IFontFace[];
	baseUrl?: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FontFaces = createGlobalStyle<IFontFacesProps>`
	${(props) => new common.commonUtils.ComponentStyle({}).getFontFacesCss(props.fontFaces || [], props.baseUrl)}
`;
